import type { TourType } from '@/config/objects/tour-types';
import { useOutletContext } from 'react-router-dom';

interface TourTypeContext {
  tourType: TourType | undefined;
  isLoading: boolean;
}

export function useTourTypeContext() {
  return useOutletContext<TourTypeContext>();
}
